// extracted by mini-css-extract-plugin
module.exports = {"condition":"TermsSubsection-module--condition--3_-UM"};